import { Component } from '@angular/core';
import { AlertController, ModalController } from 'ionic-angular';

import { MealEditPage } from './meal-edit';
import { ConfigurationProvider, MealProvider } from '../../providers/providers';
import { MealModel } from '../../models/models';

@Component({
  selector: 'page-meal',
  templateUrl: 'meal.html',
})
export class MealPage {
  mealList: any = [];
  page: string = 'meals';

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private mealProvider: MealProvider,
    private modalCtrl: ModalController) {
  }

  doAddMeal(item: MealModel = new MealModel()) {
    this.config.showLoading();
    this.mealProvider.LoadFoodItems(item).then((meal) => {
      let modal = this.modalCtrl.create(MealEditPage, { 
        item: meal
      });
  
      modal.onDidDismiss(data => {
        if (data && data.saved && data.name) {
          this.config.showToast('"' + data.name + '" saved!');
          this.loadView();
        }
      });

      this.config.dismissLoading();
      modal.present();
    });
  }

  doRemove(item: MealModel) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            this.config.showLoading('Removing...');
            this.mealProvider.Remove(item).then((items) => {
              this.mealList = items;
              this.config.showToast(item.Name + ' removed!');
              this.config.dismissLoading();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadView() {
    const processList = () => {
      if (this.mealList) {
        this.mealList = this.mealProvider.Sort();
        for (let item of this.mealList) {
          item.icon = 'arrow-dropright';
          item.showDetails = false;
        }
      };
    }

    this.mealList = this.mealProvider.List();

    if (this.mealList.length > 0) {
      processList();
    }
    else {
      this.config.showLoading();
      this.mealProvider.Load().then(() => {
        processList();
        this.config.dismissLoading();
      });
    }
  }

  toggleDetails(item) {
    const showDetails = (item) => {
      if (item.showDetails) {
        item.showDetails = false;
        item.icon = 'arrow-dropright';
      }
      else {
        item.showDetails = true;
        item.icon = 'arrow-dropdown';
      }
    };

    if (item.FoodItems) {
      showDetails(item);
    }
    else {
      this.config.showLoading();
      this.mealProvider.LoadFoodItems(item).then((meal) => {
        item = meal;
        showDetails(item);
        this.config.dismissLoading();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/meal.ts